const SHOP_IDS = {
  US: 'US',
  UK: 'UK',
  EU: 'EU',
};

const DEFAULT_SHOP_ID = SHOP_IDS.US;

const SHOPS = {
  [SHOP_IDS.US]: {
    id: SHOP_IDS.US,
    url: 'https://www.allbirds.com',
  },
  [SHOP_IDS.UK]: {
    id: SHOP_IDS.UK,
    url: 'https://www.allbirds.co.uk',
  },
  [SHOP_IDS.EU]: {
    id: SHOP_IDS.EU,
    url: 'https://www.allbirds.eu',
  },
};

const DEV_ENVIRONMENT_SUBDOMAINS = ['eu-dev'];

export { SHOP_IDS, DEFAULT_SHOP_ID, DEV_ENVIRONMENT_SUBDOMAINS };
export default SHOPS;
